import React, { ComponentPropsWithoutRef, forwardRef } from 'react';
import { clsx } from 'clsx';

import { ButtonProps } from './Button';

import styles from './Button.module.scss';

export type LinkButtonProps = ButtonProps & ComponentPropsWithoutRef<'a'>;

export const LinkButton = forwardRef<HTMLAnchorElement, LinkButtonProps>(
  ({ href, children, className, variant = 'default', ...otherProps }, ref) => {
    return (
      <a
        ref={ref}
        href={href}
        className={clsx(styles.btn, styles[variant], className)}
        {...otherProps}
      >
        {children}
      </a>
    );
  }
);
